import { ANALYTICS_CHART_MARGIN } from "@components/analytics/analytics-charts";
import {
  SphereBarChart,
  SphereBarChartProps,
} from "@components/common/sphere-bar-chart/sphere-bar-chart";
import { useMediaQueryList } from "@hooks/use-media-query";
import { CommonStyles } from "@styles/common-styles";
import { useMemo } from "react";

/** Renders a single analytics bar chart */
export function AnalyticsBarChart({
  data,
  shouldShowSkeleton,
}: SphereBarChartProps): JSX.Element {
  const { isScreenSmOrSmaller } = useMediaQueryList();

  const padding = useMemo(() => {
    if (shouldShowSkeleton) {
      return "0px";
    }
    return isScreenSmOrSmaller ? "10px" : "20px";
  }, [isScreenSmOrSmaller, shouldShowSkeleton]);

  return (
    <SphereBarChart
      data={data}
      shouldShowSkeleton={shouldShowSkeleton}
      sx={{
        width: isScreenSmOrSmaller
          ? "100%"
          : `calc(50% - ${ANALYTICS_CHART_MARGIN}/2)`,
        border: shouldShowSkeleton
          ? "none"
          : CommonStyles.Borders.gray200Divider,
        padding,
        marginBottom: ANALYTICS_CHART_MARGIN,
      }}
    />
  );
}
